import { URL, handleErrors } from "./depannageActions"
import { showToast, toastApiError } from "./toastActions"
import { getParams } from "../../utilities/Addons"
import { catchApiError } from "./apiHelpers"

export const UPDATE_ENTITE = "UPDATE_ENTITE"

export const updateEntite = (payload) => ({
	type: UPDATE_ENTITE,
	payload,
})

// État UI de la liste /clients (recherche, filtre, page) persisté dans le store
// pour survivre à la navigation vers une fiche et retour.
export const SET_ENTITES_LIST_UI = "SET_ENTITES_LIST_UI"

export const setEntitesListUi = (payload) => ({
	type: SET_ENTITES_LIST_UI,
	payload,
})

export const FETCH_ENTITES_BEGIN = "FETCH_ENTITES_BEGIN"
export const FETCH_ENTITES_SUCCESS = "FETCH_ENTITES_SUCCESS"
export const FETCH_ENTITES_ERROR = "FETCH_ENTITES_ERROR"

export const fetchEntitesBegin = () => ({
	type: FETCH_ENTITES_BEGIN,
})

export const fetchEntitesSucces = (addresses) => ({
	type: FETCH_ENTITES_SUCCESS,
	payload: addresses,
})

export const fetchEntitesError = (error) => ({
	type: FETCH_ENTITES_ERROR,
	payload: { error },
})

export function fetchEntites(params) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEntitesBegin())
		let url = `${URL}api/entites${getParams(params)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEntitesSucces(json))
			})
			.catch(catchApiError(dispatch, fetchEntitesError))
	}
}

export const DELETE_ENTITE_BEGIN = "DELETE_ENTITE_BEGIN"
export const DELETE_ENTITE_ERROR = "DELETE_ENTITE_ERROR"
export const DELETE_ENTITE_SUCCESS = "DELETE_ENTITE_SUCCESS"
export const DELETE_ENTITE_RESET = "DELETE_ENTITE_RESET"

export const deleteEntiteBegin = () => ({
	type: DELETE_ENTITE_BEGIN,
})

export const deleteEntiteReset = () => ({
	type: DELETE_ENTITE_RESET,
})

export const deleteEntiteError = (payload) => ({
	type: DELETE_ENTITE_ERROR,
	payload,
})

export const deleteEntiteSuccess = (payload) => ({
	type: DELETE_ENTITE_SUCCESS,
	payload,
})

export function deleteEntite(body) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteEntiteBegin())
		return fetch(`${URL}api/entites`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(body),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteEntiteSuccess(json))
			})
			// silent : l'erreur s'affiche dans le modal de ClientFicheV2.
			.catch(catchApiError(dispatch, deleteEntiteError, { silent: true }))
	}
}

export const DELETE_VEHICULE_BEGIN = "DELETE_VEHICULE_BEGIN"
export const DELETE_VEHICULE_ERROR = "DELETE_VEHICULE_ERROR"
export const DELETE_VEHICULE_SUCCESS = "DELETE_VEHICULE_SUCCESS"
export const DELETE_VEHICULE_RESET = "DELETE_VEHICULE_RESET"

export const deleteVehiculeBegin = () => ({
	type: DELETE_VEHICULE_BEGIN,
})

export const deleteVehiculeReset = () => ({
	type: DELETE_VEHICULE_RESET,
})

export const deleteVehiculeError = (payload) => ({
	type: DELETE_VEHICULE_ERROR,
	payload,
})

export const deleteVehiculeSuccess = (payload) => ({
	type: DELETE_VEHICULE_SUCCESS,
	payload,
})

export function deleteVehicule(vehiculeId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteVehiculeBegin())
		return fetch(`${URL}api/vehicule`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ vehiculeId, type: "vehicule" }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteVehiculeSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteVehiculeError))
	}
}

export const DELETE_CARTE_GRISE_BEGIN = "DELETE_CARTE_GRISE_BEGIN"
export const DELETE_CARTE_GRISE_SUCCESS = "DELETE_CARTE_GRISE_SUCCESS"
export const DELETE_CARTE_GRISE_ERROR = "DELETE_CARTE_GRISE_ERROR"
export const DELETE_CARTE_GRISE_RESET = "DELETE_CARTE_GRISE_RESET"

export const deleteCarteGriseBegin = () => ({
	type: DELETE_CARTE_GRISE_BEGIN,
})

export const deleteCarteGriseSuccess = (payload) => ({
	type: DELETE_CARTE_GRISE_SUCCESS,
	payload,
})

export const deleteCarteGriseError = (payload) => ({
	type: DELETE_CARTE_GRISE_ERROR,
	payload,
})

export const deleteCarteGriseReset = () => ({
	type: DELETE_CARTE_GRISE_RESET,
})

export function deleteCarteGrise(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteCarteGriseBegin())
		return fetch(`${URL}api/vehicule`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteCarteGriseSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteCarteGriseError))
	}
}

export const DELETE_FILE_VEHICULE_BEGIN = "DELETE_FILE_VEHICULE_BEGIN"
export const DELETE_FILE_VEHICULE_SUCCESS = "DELETE_FILE_VEHICULE_SUCCESS"
export const DELETE_FILE_VEHICULE_ERROR = "DELETE_FILE_VEHICULE_ERROR"
export const DELETE_FILE_VEHICULE_RESET = "DELETE_FILE_VEHICULE_RESET"

export const deleteFileVehiculeBegin = () => ({
	type: DELETE_FILE_VEHICULE_BEGIN,
})

export const deleteFileVehiculeSuccess = (payload) => ({
	type: DELETE_FILE_VEHICULE_SUCCESS,
	payload,
})

export const deleteFileVehiculeError = (payload) => ({
	type: DELETE_FILE_VEHICULE_ERROR,
	payload,
})

export const deleteFileVehiculeReset = () => ({
	type: DELETE_FILE_VEHICULE_RESET,
})

export function deleteFileVehicule(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteFileVehiculeBegin())
		return fetch(`${URL}api/vehicule_file`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteFileVehiculeSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteFileVehiculeError))
	}
}

export const POST_ENTITE_BEGIN = "POST_ENTITE_BEGIN"
export const POST_ENTITE_SUCCESS = "POST_ENTITE_SUCCESS"
export const POST_ENTITE_ERROR = "POST_ENTITE_ERROR"
export const POST_ENTITE_RESET = "POST_ENTITE_RESET"

export const postEntiteBegin = () => ({
	type: POST_ENTITE_BEGIN,
})

export const postEntiteSuccess = (payload) => ({
	type: POST_ENTITE_SUCCESS,
	payload,
})

export const postEntiteError = (payload) => ({
	type: POST_ENTITE_ERROR,
	payload,
})

export const postEntiteReset = () => ({
	type: POST_ENTITE_RESET,
})

export function postEntite(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEntiteBegin())
		return fetch(`${URL}api/entites`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postEntiteSuccess(json))
				dispatch(showToast("success", "Modifications enregistrées"))
				return json
			})
			// silent : l'erreur s'affiche dans le modal de ClientFicheV2.
			.catch(catchApiError(dispatch, postEntiteError, { silent: true }))
	}
}

// Suppression d'UNE adresse déjà sauvegardée d'un client (détache le
// ComplementAdresse côté serveur). Renvoie le client à jour — le composant
// (state local) met à jour ses adresses depuis la réponse. Retourne null si KO.
export function deleteClientAdresse(entiteId, complementId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/adresse`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				entite_id: entiteId,
				complement_id: complementId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Adresse supprimée"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Suppression immédiate d'une personne / fourniture d'une entité. Renvoie
// l'entité à jour ; un message clair remonte si bloquée par une FK.
export function deleteEntitePersonne(entiteId, personneId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/personne`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				entite_id: entiteId,
				personne_id: personneId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Personne supprimée"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

export function deleteEntiteFourniture(entiteId, fournitureId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/fourniture`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				entite_id: entiteId,
				fourniture_id: fournitureId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Fourniture supprimée"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Suppression immédiate d'une assurance d'une entité Assistance (endpoint
// dédié, miroir de deleteEntiteFourniture). Renvoie l'entité à jour.
export function deleteEntiteAssurance(entiteId, assuranceId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/assurance`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				entite_id: entiteId,
				assurance_id: assuranceId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Assurance supprimée"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Véhicules d'un client : save/suppression par véhicule (endpoint dédié, SANS
// propre_vehicule). Renvoie le client à jour ; le composant (state local) met à
// jour entite.vehicules depuis la réponse. Retourne null si KO.
export function postClientVehicule(entiteId, vehicule) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/vehicule`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ entite_id: entiteId, vehicule }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(
					showToast(
						"success",
						vehicule.id ? "Véhicule modifié" : "Véhicule ajouté",
					),
				)
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

export function deleteClientVehicule(entiteId, vehiculeId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/vehicule`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				entite_id: entiteId,
				vehicule_id: vehiculeId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Véhicule supprimé"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Documents d'un véhicule (carte grise + fichiers "autres"). Upload multipart
// via api/vehicule_file (renvoie le véhicule), suppression via
// api/vehicule/document. Renvoie le véhicule à jour, null si KO.
export function uploadVehiculeDocuments(vehiculeId, { carteGrise, files }) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const fd = new FormData()
		fd.append("id", vehiculeId)
		if (carteGrise) fd.append("carte_grise", carteGrise)
		;(files || []).forEach((f, i) => fd.append(`file_${i}`, f))
		return fetch(`${URL}api/vehicule_file`, {
			method: "post",
			headers: { Authorization: `Bearer ${token}` },
			body: fd,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Document(s) enregistré(s)"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

export function deleteVehiculeDocument(vehiculeId, { type, fileId }) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/vehicule/document`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				vehicule_id: vehiculeId,
				type,
				file_id: fileId,
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(showToast("success", "Document supprimé"))
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Sauvegarde V2 d'une entité (endpoint dédié JSON : base + adresses + personnes
// + fournitures, create/update/prune côté serveur). Renvoie l'entité, null si KO.
export function saveEntiteV2(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entite/save`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(
					showToast(
						"success",
						data.id ? "Entité modifiée" : "Entité créée",
					),
				)
				return json
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}

// Suppression d'une entité (réutilise api/entites). Renvoie true, null si KO
// (un message clair remonte si bloquée par des fiches liées).
export function deleteEntiteV2(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/entites`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then(() => {
				dispatch(showToast("success", "Entité supprimée"))
				return true
			})
			.catch((err) => {
				dispatch(toastApiError(err))
				return null
			})
	}
}
